import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  category: "",
};

const navigationSlice = createSlice({
  name: "navigation",
  initialState,
  reducers: {
    setCategory: (state, action) => {
      state.category = action.payload;
    },
    clearCategory: (state) => {
      state.category = "";
    },
  },
});

export const { setCategory, clearCategory } = navigationSlice.actions;
export default navigationSlice.reducer;
